import {lazy} from 'react';

export const ChatAsync = lazy(() =>
    import('./Chat')
);
